// extracted by mini-css-extract-plugin
module.exports = {"App":"LandlingPage_App__N3XQD","Title":"LandlingPage_Title__1HNiB","Main":"LandlingPage_Main__3bOTA"};